export enum PayoutType {
  Crypto = 'Crypto',
  Fiat = 'Fiat'
}

export enum PayoutSteps {
  SelectAssets,
  SelectDetails,
  ReviewAndConfirm
}
